export abstract class IdGenerator {
  abstract generate(): string;
}
